import defaultsDeep from 'lodash/defaultsDeep';
import merge from 'lodash/merge';
export function defineMessages(locale, app, defaultAppMessages) {
    let defaultCommonMessages;
    try {
        defaultCommonMessages = require(`./lang/${locale}.common.json`);
    }
    catch (_a) {
        defaultCommonMessages = {};
    }
    let brandCommonMessages;
    try {
        brandCommonMessages = require(`../../../var/insurer/lang/${locale}.common.json`);
    }
    catch (_b) {
        brandCommonMessages = {};
    }
    let brandAppMessages;
    try {
        brandAppMessages = require(`../../../var/insurer/lang/${locale}.${app}.json`);
    }
    catch (_c) {
        brandAppMessages = {};
    }
    const commonMessages = defaultsDeep(brandCommonMessages, defaultCommonMessages);
    const appMessages = defaultsDeep(brandAppMessages, defaultAppMessages);
    return merge(commonMessages, appMessages);
}
